import React, { ComponentType, ReactNode, useContext } from 'react';

import { ErrorControllerProps } from '../ErrorController';

import {
  SMFooter,
  SMHeader,
  MobileBanner,
  SessionTimeoutModal,
  CookieBanner,
  StaticContext,
  ErrorController,
} from '../..';
import { BRAND } from '../Header/enums';

export type BasePageBodyProps<TErrorCtrlData = unknown> = {
  color?: string;
  includeHeader?: boolean;
  includeFooter?: boolean;
  errorCtrl?: ErrorControllerProps<TErrorCtrlData>;
  showBillingAddress?: boolean;
  headerVariant?: 'default' | 'limited' | 'slim';
  footerVariant?: 'default' | 'limited' | 'slim';
  actionFlow?: string;
  showCreateSurveyButton?: boolean;
  sticky?: boolean;
  isMRX?: boolean;
  isPrivateLabel?: boolean;
  excludeMenuItems?: string[];
  showLoginButton?: boolean;
  showSignupButton?: boolean;
  displayLICTA?: boolean;
  showDrawer?: boolean;
  Logo?: ComponentType<unknown>;
  children: ReactNode;
};

const BasePageBody = ({
  color = 'primary',
  headerVariant = 'default',
  footerVariant = 'default',
  errorCtrl,
  showBillingAddress = false,
  includeHeader = true,
  includeFooter = true,
  children,
  actionFlow = 'header',
  showCreateSurveyButton = true,
  sticky = true,
  isMRX = false,
  isPrivateLabel = false,
  excludeMenuItems = [],
  showLoginButton = true,
  showSignupButton = true,
  displayLICTA = true,
  showDrawer = true,
  Logo,
}: BasePageBodyProps) => {
  const {
    user,
    url,
    environment,
    locale,
    'client-config': clientConfig,
    GDPR,
  } = useContext(StaticContext);

  const {
    languageCode: language,
    countryCode: country,
    subdomain,
    domain,
    tld,
  } = environment;

  return (
    <>
      {includeHeader ? (
        <SMHeader
          isAnonHeaderSticky={sticky}
          isUserAuthenticated={user.isAuthenticated}
          color={color}
          variant={headerVariant}
          lang={language}
          isEUDC={locale.isEUDC}
          actionFlow={actionFlow}
          user={user}
          showCreateSurveyButton={showCreateSurveyButton}
          isMRX={isMRX}
          excludeMenuItems={excludeMenuItems}
          showLoginButton={showLoginButton}
          showSignupButton={showSignupButton}
          displayLICTA={displayLICTA}
          showDrawer={showDrawer}
          Logo={Logo}
          brand={isPrivateLabel ? BRAND.MOMENTIVE : BRAND.SURVEYMONKEY}
        />
      ) : null}
      {errorCtrl ? (
        <ErrorController {...errorCtrl}>{children}</ErrorController>
      ) : (
        <>{children}</>
      )}
      {includeFooter ? (
        <SMFooter
          subdomain={subdomain}
          domain={domain}
          lang={language}
          country={country}
          isUserAuthenticated={user.isAuthenticated}
          showBillingAddress={showBillingAddress}
          variant={footerVariant}
          isEUDC={locale.isEUDC}
          isPrivateLabel={isPrivateLabel}
          tld={tld}
          url={url}
          onetrustBannerEnabled={GDPR.onetrustBannerEnabled}
        />
      ) : null}
      {user.isAuthenticated ? (
        <>
          <SessionTimeoutModal user={user} />
          <MobileBanner
            downloadLink={clientConfig.mobileBannerDownloadLink}
            deepLinkData={undefined}
          />
        </>
      ) : null}
      {!GDPR.onetrustBannerEnabled ? <CookieBanner GDPR={GDPR} /> : null}
    </>
  );
};

export default BasePageBody;
